import axios from "axios";
import {
  BANK_ACCOUNT_LIST_ATTEMPT,
  BANK_ACCOUNT_LIST_SUCCESS,
  BANK_ACCOUNT_LIST_FAILED,
  ///////////////////////
  BANK_ACCOUNT_SAVE_ATTEMPT,
  BANK_ACCOUNT_SAVE_SUCCESS,
  BANK_ACCOUNT_SAVE_FAILED,
} from "../types/bankAccountTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: BANK_ACCOUNT_LIST_ATTEMPT };
}

export function success(data) {
  return { type: BANK_ACCOUNT_LIST_SUCCESS, data };
}

export function failed(error) {
  return { type: BANK_ACCOUNT_LIST_FAILED, error };
}

export function saving() {
  return { type: BANK_ACCOUNT_SAVE_ATTEMPT };
}

export function saveSuccess(data) {
  return { type: BANK_ACCOUNT_SAVE_SUCCESS, data };
}

export function saveFailed(error) {
  return { type: BANK_ACCOUNT_SAVE_FAILED, error };
}

function buildFormData(user_id, params) {
  const form = new FormData();
  form.append("id", user_id);
  if (params.account_id) form.append("account_id", params.account_id);
  form.append("holder_name", params.holder_name || "");
  form.append("identification", params.identification || "");
  form.append("bank", params.bank || "");
  form.append("account_number", params.account_number || "");
  form.append("account_type", params.account_type || "");
  if (params.remove_qr) form.append("remove_qr", "true");
  if (params.qr) form.append("qr", params.qr);
  return form;
}

export const loadList = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "bankaccount", {
      params: { id: data.user_id },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(failed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const newItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const form = buildFormData(data.user_id, data.params);
    const response = await axios.post(url_api + "bankaccount", form, {
      headers: {
        Authorization: `Bearer ${data.token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const updateItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const form = buildFormData(data.user_id, data.params);
    const response = await axios.put(url_api + "bankaccount", form, {
      headers: {
        Authorization: `Bearer ${data.token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const removeItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.delete(url_api + "bankaccount", {
      headers: { Authorization: `Bearer ${data.token}` },
      data: { id: data.user_id, account_id: data.account_id },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
